import { Api } from "./api"

export class CuppingSessionsLocationApi extends Api {
  constructor() {
    super('locations', [], { prefix: "cupping_sessions" })
  }
}
